module.exports = __webpack_public_path__ + "static/media/forumbee.5768e3db.svg";